"use strict";

angular.module("dokiv")
  .factory("stateSnapshot", ["$rootScope", function($rootScope) {
    var obj = {
      previous: {
        state:  null,
        params: {}
      },
      current: {
        state:  null,
        params: {}
      },
      next: {
        state:  null,
        params: {}
      }
    };
    
    $rootScope.$on("$stateChangeStart", function(e, toState, toParams, fromState, fromParams) {
      obj.previous = {
        state:  fromState,
        params: fromParams
      };
      
      obj.next = {
        state:  toState,
        params: toParams
      };
    });
    
    $rootScope.$on("$stateChangeSuccess", function(e, toState, toParams) {
      obj.current = {
        state:  toState,
        params: toParams
      };
    });
    
    return obj;
  }])
  .run(["stateSnapshot", function() {
    /* Needed to initialize the stateSnapshot hooks */
  }]);



//////////////////
// WEBPACK FOOTER
// ./scripts/app/stateSnapshot.js
// module id = 272
// module chunks = 0